import React, { useEffect, useMemo, useState } from "react";
import { fetchProducts } from "../lib/api";
import { useSiteSettings, settingImage } from "../lib/siteSettings";
import ProductCard from "../components/ProductCard";
import PageHero from "../components/PageHero";

const CATEGORIES = ["Todos", "Etiquetas", "Ribbons", "Impressoras"];

export default function Produtos() {
  const [products, setProducts] = useState([]);
  const [active, setActive] = useState("Todos");
  const [loading, setLoading] = useState(true);
  const { settings } = useSiteSettings();

  useEffect(() => {
    fetchProducts()
      .then((data) => setProducts(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.error("Erro ao carregar produtos:", err);
        setProducts([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    if (!Array.isArray(products)) return [];
    if (active === "Todos") {
      // Show Etiquetas + Ribbons first, then Impressoras, to give Etiquetas more prominence
      const order = { Etiquetas: 0, Ribbons: 1, Impressoras: 2 };
      return [...products].sort((a, b) => (order[a.category] ?? 9) - (order[b.category] ?? 9));
    }
    return products.filter((p) => p.category === active);
  }, [products, active]);

  return (
    <main data-testid="produtos-page" className="bg-white">
      <PageHero
        overline="CATÁLOGO COMPLETO"
        title="Produtos & Soluções"
        subtitle="Etiquetas personalizadas, ribbons e impressoras térmicas, laser e jato de tinta — tudo o que sua operação precisa em um só parceiro."
        image={settingImage(settings?.cover_produtos)}
      />

      {/* FILTERS + LIST */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
          <div className="flex flex-wrap gap-3 mb-12 border-b border-[#E5E7EB] pb-6">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                data-testid={`filter-${c.toLowerCase()}`}
                className={`px-5 py-2.5 text-xs font-bold uppercase tracking-[0.2em] transition-colors ${
                  active === c
                    ? "bg-[#1A1A1A] text-white"
                    : "bg-transparent text-[#1A1A1A] border border-[#E5E7EB] hover:border-[#1A1A1A]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          {loading ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="bg-[#F9F9F9] aspect-[3/4] animate-pulse" />
              ))}
            </div>
          ) : filtered.length === 0 ? (
            <div className="text-center py-16 text-[#6B7280]">Nenhum produto encontrado nesta categoria.</div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
